var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[
    _vm.className,
    (_vm.className + "--" + _vm.type)
  ],style:(_vm.styleObject),attrs:{"data-test":_vm.className}},[_c('i',{class:_vm.dotClassName}),_c('i',{class:_vm.dotClassName}),_c('i',{class:_vm.dotClassName})])}
var staticRenderFns = []

export { render, staticRenderFns }